import React from 'react'

const ShowroomModule = () => {
  return (
    <>
        <div>Showroom Module</div>
    </>
  )
}

export default ShowroomModule